import appConfig from '@src/app.config'

export default function getSecret(key) {
  return appConfig[`${appConfig.ENVIRONMENT.toUpperCase()}_${key.toUpperCase()}`] || appConfig[key.toUpperCase()];
}